import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-257">
      <img src="https://cdn.magicpatterns.com/uploads/bRTdnW7TN8NYr23s2z5e3f/ChatGPT_Image_Apr_27,_2026,_02_44_47_PM.png" alt="Author Leverage Logo" className="h-10 w-auto object-contain drop-shadow-sm" data-id="element-258" />
      <span className="font-serif font-semibold text-navy text-2xl tracking-tight" data-id="element-259">
        Author Leverage
      </span>
    </div>;
}